import { NotificationPageModel as Model } from './Model'


export const MODULE_NAME = 'help_pages_routes'
export const MODULE_NAME_CACHES = 'help-pages-cache'

export const NOTIFICATION_PAGES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: NOTIFICATION_PAGES_ROUTES.LAYOUT,
  route: { name: NOTIFICATION_PAGES_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-lifebuoy',
} as const
